// Calendar Events Data
export const myevents = [
  {
    id: 0,
    title: "Children's Day Celebration",
    start: new Date(2022, 10, 14, 10, 0, 0),
    end: new Date(2022, 10, 14, 13, 0, 0),
    resourceId: 1
  },
  {
    id: 1,
    title: "Health Department Seminar",
    start: new Date(2022, 10, 20, 9, 0, 0),
    end: new Date(2022, 10, 20, 12, 30, 0),
    resourceId: 2
  },
  {
    id: 2,
    title: "School Tour",
    start: new Date(2022, 10, 25, 8, 0, 0),
    end: new Date(2022, 10, 25, 20, 0, 0),
    resourceId: 3
  },
  {
    id: 3,
    title: "Tech Fest",
    start: new Date(2022, 10, 27, 8, 0, 0),
    end: new Date(2022, 10, 27, 16, 30, 0),
    resourceId: 4
  },
  {
    id: 4,
    title: "Christmas Celebration",
    start: new Date(2022, 11, 24, 8, 0, 0),
    end: new Date(2022, 11, 24, 16, 30, 0),
    resourceId: 5
  },
  {
    id: 5,
    title: "HalfYearly Examinations",
    start: new Date(2022, 11, 15, 10, 0, 0),
    end: new Date(2022, 11, 22, 13, 30, 0),
    resourceId: 5
  },

]
